import { operationInProgress } from '../action/profile.action'
import ActionType from '../action.types'
import serviceInterface from '../../services/service.interface'
import { message } from 'antd'
import { some } from 'lodash'

/*
Actions to be dispatched for signin


*/

export function serviceError(bool, message) {
  return {
    type: ActionType.EVENT_SERVICE_ERROR,
    hasError: bool,
    message,
  }
}

export function fetchInProgress(bool) {
  return {
    type: ActionType.EVENTS_INPROGRESS,
    isLoading: bool,
  }
}

export function setSurgeryType(surgerytype) {
  return {
    type: ActionType.SET_SURGERY_TYPE,
    surgerytype,
  }
}

export function setEventList(events, surgerytype) {
  return {
    type: ActionType.SET_EVENTS,
    events,
    surgerytype,
  }
}

export function setIsEventUpdate(isUpdated) {
  return {
    type: ActionType.SET_ISUPDATE,
    isUpdated,
  }
}
export function setEventDiffs(differences) {
  return {
    type: ActionType.SET_EVENT_DIFFERENCES,
    differences,
  }
}

export function setChangedEvents(changedevents) {
  return {
    type: ActionType.SET_CHANGED_EVENTS,
    changedevents,
  }
}

export function setIsUpdated(isUpdated, updatedAt) {
  return {
    type: ActionType.SET_EVENT_UPDATED,
    isUpdated,
    updatedAt,
  }
}

export function setTempEvents(tempevents) {
  return {
    type: ActionType.SET_TEMP_EVENTS,
    tempevents,
  }
}

export function getEvents(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.EventService().getAllEvents(params)
      dispatch(fetchInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else dispatch(setEventList(data.events, params.surgerytype))
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function addEditEvent(params, events) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .EventService()
        .addEditEvent(params, events)
      dispatch(fetchInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else dispatch(setEventList(data.events, params.surgerytype))
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function deleteEvent(params, events) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface
        .EventService()
        .deleteEvent(params, events)
      dispatch(fetchInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else dispatch(setEventList(data.events, params.surgerytype))
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function isEventUpdated(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.EventService().isEventUpdated(params)
      dispatch(fetchInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else dispatch(setIsUpdated(data.isupdated, data.time))
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function getDifference(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.EventService().getDifferences(params)
      dispatch(fetchInProgress(false))
      if (data.error) message.error(data.message)
      else {
        dispatch(setEventDiffs(data.differences))
        const hasUpdated = some(data.differences, (diff) =>
          some(diff.events, (event) => event.isUpdated)
        )

        dispatch(setIsEventUpdate(hasUpdated))
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function importFromMaster(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.EventService().importFromMaster(params)
      dispatch(fetchInProgress(false))
      if (data.error) message.error(data.message)
      else return data
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function discardMasterChanges(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.EventService().discardEvents(params)
      dispatch(fetchInProgress(false))
      if (data.error) message.error(data.message)
      else return data
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}

export function bulkAddEditEvents(params) {
  return async (dispatch) => {
    try {
      dispatch(fetchInProgress(true))
      var data = await serviceInterface.EventService().bulkAddEditEvent(params)
      dispatch(fetchInProgress(false))
      if (data.error) dispatch(serviceError(true, data.message))
      else {
        message.success('Your changes have been published successfully.')
        dispatch(getEvents(params))
        return data
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchInProgress(false))
      dispatch(serviceError(true, 'error communicating with the server'))
    }
  }
}
